export default {
    data: function() {
        return {
            mapTools: [
                { name: 'zoom', css: 'right: 10px; bottom: 90px' },
                { name: 'street', css: 'right: 10px; bottom: 30px' },
                { name: 'maptype', css: 'left: 20px; top: 20px' }
            ],
            mobileMapTools: [
                { name: 'street', css: 'right: 10px; bottom: 20px' }
            ],
            markerData: {
                location: {
                    address: this.address
                },
                icon: 'icon-map',
                showAddress: true
            }
        };
    },
    created() {
        //  Define map module loading 
        this.psMap = new Promise(resolve => {
            this.psResolve = resolve;
        });
    },
    computed: {
        isMobile() {
            return this.platform.isMobile;
        },
        showTools() {
            return this.isMobile ? this.mobileMapTools : this.mapTools;
        },
        center() {
            if (this.lat && this.lng) {
                return {
                    lat: this.lat,
                    lng: this.lng
                };
            } else {
                return null;
            }
        }
    },
    watch: {
        address() {
            this.updateLocationMarker();
        }
    },
    methods: {
        mapLoad(siteMap, map, maps) {
            this.siteMap = siteMap;
            this.map = map;
            this.maps = maps;
            this.psResolve();
            this.updateLocationMarker();
        },
        updateLocationMarker() {
            this.psMap.then(() => {
                this.markerData = Object.assign({}, this.markerData, {
                    location: this.address
                        ? {
                            address: this.address,
                            ...(this.center || this.siteMap.config.center)
                        }
                        : null
                });
            });
        }
    }
};
